import * as React from "react"

const useBeforeUnload = (isActive: boolean) => {
  React.useEffect(() => {
    if (isActive) {
      const listener = (e: BeforeUnloadEvent) => {
        e.preventDefault()
        e.returnValue = ""
      }
      window.addEventListener("beforeunload", listener)
      return () => window.removeEventListener("beforeunload", listener)
    }
  }, [isActive])
}

export default useBeforeUnload
